import { boolean, InferType, object, string } from 'yup'

export interface IConfigurableBuilderTestOptionsSchema {
  name: string
  notes: string
  isLive: boolean
}

export const ConfigurableBuilderTestOptionsSchema = object<IConfigurableBuilderTestOptionsSchema>({
  name: string().required('Test name is required'),
  notes: string(),
  isLive: boolean(),
})

export type TConfigurableBuilderTestOptionsSchema = InferType<
  typeof ConfigurableBuilderTestOptionsSchema
>
